var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex items-center justify-center notfound" },
    [
      _c("div", { staticClass: "http404" }, [
        _c("div", { staticClass: "pic-404" }, [
          _c("img", {
            staticClass: "pic-404__parent",
            attrs: { src: _vm.img_404, alt: "404" },
          }),
          _c("img", {
            staticClass: "pic-404__child left",
            attrs: { src: _vm.img_404_cloud, alt: "404" },
          }),
          _c("img", {
            staticClass: "pic-404__child mid",
            attrs: { src: _vm.img_404_cloud, alt: "404" },
          }),
          _c("img", {
            staticClass: "pic-404__child right",
            attrs: { src: _vm.img_404_cloud, alt: "404" },
          }),
        ]),
        _c("div", { staticClass: "bullshit" }, [
          _c("div", { staticClass: "bullshit__oops" }, [_vm._v("温馨提示!")]),
          _c("div", { staticClass: "bullshit__headline" }, [
            _vm._v(_vm._s(_vm.message)),
          ]),
          _c("div", { staticClass: "bullshit__info" }, [
            _vm._v("请联系管理员或者返回首页"),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }